module.exports = __webpack_public_path__ + "production/v2.18.16/img/corporate.0d4a1b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/assets/images/corporate.png
// module id = 6lg3
// module chunks = 29